import { GroupedChartDataPoint } from "../types/chart-data";

export function calculateMovingAverage(
  data: GroupedChartDataPoint[],
  window: number,
): GroupedChartDataPoint[] {
  return data.map((item, index) => {
    if (index < window - 1) return { ...item, movingAvg: null };

    const sum = data
      .slice(index - window + 1, index + 1)
      .reduce((acc, curr) => acc + curr.count, 0);

    return { ...item, movingAvg: Number((sum / window).toFixed(2)) };
  });
}
